import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — resets the window scroll position to (0,0) whenever the
 * pathname changes. Fixes the common React Router UX gap where clicking a
 * link at the bottom of a long page (e.g. footer → /privacy) leaves the new
 * page scrolled to the bottom, making users think the link didn't work.
 *
 * Renders nothing. Must be mounted inside <BrowserRouter>.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip smooth-scroll here — an instant jump feels correct on page change.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
